import { BaseHandler } from "../../../infrastructure/base-handlers";
import { translate } from "../../../localization";
import { existItemInCollection } from "../../domain/exist-item-in-collection";
import { IActivityHistoryItem } from "../../domain/model";
import { validateAndFilterBasicItems } from "../../domain/validation/is-valid-basic-history-item";
import { AddCustomFiltersCommand } from "../../filter/custom-filters/add-custom-filters/request";
import { handleAddUpFilter } from "../../filter/up-filters/handle-add-up-options-from-item";
import { addActivityHistoryItems } from "./action";
import { AddHistoryItemsPayload } from "./request";

export class AddHistoryItemsHandler extends BaseHandler {
  async handle(payload: AddHistoryItemsPayload) {
    try {
      const validItems = validateAndFilterBasicItems(payload.items);
      const newItems = this.filterDuplicateItems(validItems, payload.entityId);
      const state = this.store.getState();
      const existFilterGroup = state.activityHistoryFilters?.filters?.find((item) => item.id === payload.entityId);

      // Los filtros son obligatorios: debe existir un grupo previo O proporcionar uno nuevo
      if (!existFilterGroup && !payload.filters) {
        throw new Error(translate("error.filterNotInitialized"));
      }

      if (newItems.length > 0) {
        handleAddUpFilter(newItems, this.store);
      }

      this.store.dispatch(
        addActivityHistoryItems({
          id: payload.entityId,
          items: newItems,
          componentFactory: payload.componentFactory,
          searchPredicate: payload.searchPredicate,
          historyDataImporterRules: payload.historyDataImporterRules,
        }),
      );

      if (payload.filters) {
        this.api.broker.send(new AddCustomFiltersCommand(payload.filters));
      }
    } catch (e) {
      this.api.notificationService.error(e.message);
    }
  }

  private filterDuplicateItems(validItems: IActivityHistoryItem[], entityId: string): IActivityHistoryItem[] {
    if (validItems.length === 0) {
      return [];
    }

    const state = this.store.getState();
    const newItems = validItems.filter(
      (item) => !existItemInCollection(state.activityHistoryCollections?.collections, entityId, item.id),
    );

    // If all items already exist, throw error
    if (newItems.length === 0 && validItems.length > 0) {
      throw new Error(translate("error.allItemsAlreadyExist"));
    }

    // If some items were filtered, show warning
    if (newItems.length < validItems.length) {
      this.api.notificationService.warning(translate("warning.someItemsAlreadyExist"));
    }

    return newItems;
  }
}
